import Component from '@bythepixel/component-loader';
import Map from './map';

export default class largeMap extends Component {
  static selector = '[data-comp-map]'
  #map

  constructor(...args) {
    super(...args);
    this.#map = new Map(this.$container);
    this.events();
    this.addMarker = this.addMarker.bind(this);
    this.fitBounds = this.fitBounds.bind(this);
  }

  events() {
    this.$subscribe('hide-location', (data) => {
      this.removeMarker(data);
    });
    this.$subscribe('show-location', (data) => {
      this.addMarker(data);
    });
    this.$subscribe('fit-bounds', () => {
      this.#map.fitBoundsToVisible();
    });
  }

  addMarker(data) {
    return this.#map.addMarker(data);
  }

  removeMarker(data) {
    return this.#map.removeMarker(data);
  }

  addInfoWindow(data) {
    return this.#map.addInfoWindow(data);
  }

  setCenter(lat, lng) {
    this.#map.setCenter(lat, lng);
  }

  fitBounds() {
    return this.#map.fitBounds();
  }

  flyTo(lat, lng) {
    this.#map.flyTo({
      center: [lat, lng],
      padding: 100,
      zoom: 9,
    });
  }

  get() {
    return this.#map.get();
  }

  on(event, cb) {
    this.#map.on(event, cb);
  }
}
